/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class LogSourceLocationCloudTrail {
  /**
  * S3 prefix where CloudTrail logs are stored.
  */
  'prefix'?: string;
  /**
  * AWS account ID for the CloudTrail logs.
  */
  'accountId'?: string;
  /**
  * AWS region for the CloudTrail logs.
  */
  'region'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "prefix",
      "baseName": "prefix",
      "type": "string",
      "format": ""
    },
    {
      "name": "accountId",
      "baseName": "accountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return LogSourceLocationCloudTrail.attributeTypeMap;
  }

  public constructor() {
  }
}

